import { $i } from '@silae/composables';

export const edpIconAliases = {
	infoCircleLight: $i('info-circle'),
	check: $i('check')
};
